import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    fetchPromoterDetail({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Credits/api/PartiesQuery/partyid/" + id)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => reject(e));
      });
    },
  },
  mutations: {},
};
